// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Tutorial System Styles
 * Designed for older, less tech-savvy users:
 * - Large text and touch targets
 * - High contrast
 * - Simple, clean design
 */

/* ========================================
   TUTORIAL OVERLAY
   ======================================== */

.tutorial-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3500; /* Above modals (2000) and ProcessingDialog (3000) */
  pointer-events: none;
}

/* ========================================
   SPOTLIGHT EFFECT
   Uses box-shadow trick for dimming
   ======================================== */

.tutorial-spotlight {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* Allow clicks to pass through to underlying elements */
  pointer-events: none;
}

.tutorial-spotlight-hole {
  position: fixed;
  border-radius: 8px;
  /* Large box-shadow creates the dim overlay effect */
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.4);
  /* Allow clicks to pass through the spotlight hole */
  pointer-events: none;
  /* Smooth transitions when moving between elements */
  transition: all 0.3s ease-out;
}

/* Pulsing highlight animation to draw attention */
.tutorial-spotlight-hole::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 3px solid var(--color-primary, #3b82f6);
  border-radius: 12px;
  animation: tutorial-pulse 2s ease-in-out infinite;
}

@keyframes tutorial-pulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.02);
  }
}

/* ========================================
   TOOLTIP STYLES
   Designed for older users: large text,
   high contrast, simple language
   ======================================== */

.tutorial-tooltip {
  position: fixed;
  width: 320px;
  max-width: calc(100vw - 32px);
  background: var(--color-card-bg, #ffffff);
  border-radius: 16px;
  padding: 24px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.2),
    0 0 0 4px var(--color-primary, #3b82f6);
  pointer-events: auto;
  z-index: 3501;
  animation: tutorial-tooltip-appear 0.3s ease-out;
}

@keyframes tutorial-tooltip-appear {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Center position for completion step */
.tutorial-tooltip--center {
  text-align: center;
}

/* ========================================
   TOOLTIP ARROW
   ======================================== */

.tutorial-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border: 14px solid transparent;
}

/* Arrow pointing up (tooltip is below target) */
.tutorial-tooltip-arrow--top {
  top: -28px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom-color: var(--color-primary, #3b82f6);
}

/* Arrow pointing down (tooltip is above target) */
.tutorial-tooltip-arrow--bottom {
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: var(--color-primary, #3b82f6);
}

/* Arrow pointing left (tooltip is to right of target) */
.tutorial-tooltip-arrow--left {
  left: -28px;
  top: 50%;
  transform: translateY(-50%);
  border-right-color: var(--color-primary, #3b82f6);
}

/* Arrow pointing right (tooltip is to left of target) */
.tutorial-tooltip-arrow--right {
  right: -28px;
  top: 50%;
  transform: translateY(-50%);
  border-left-color: var(--color-primary, #3b82f6);
}

/* ========================================
   TOOLTIP CONTENT
   Large, readable text for older users
   ======================================== */

.tutorial-tooltip-content {
  margin-bottom: 20px;
}

.tutorial-tooltip-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--color-text, #1f2937);
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.tutorial-tooltip-text {
  font-size: 1.15rem;
  color: var(--color-text-secondary, #6b7280);
  margin: 0;
  line-height: 1.6;
}

/* ========================================
   PROGRESS INDICATOR
   ======================================== */

.tutorial-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-border, #d1d5db);
}

.tutorial-progress-text {
  font-size: 0.95rem;
  color: var(--color-text-secondary, #6b7280);
}

.tutorial-progress-dots {
  display: flex;
  gap: 8px;
}

.tutorial-progress-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--color-border, #d1d5db);
  transition: all 0.2s ease;
}

.tutorial-progress-dot.active {
  background: var(--color-primary, #3b82f6);
  transform: scale(1.3);
}

.tutorial-progress-dot.completed {
  background: var(--color-success, #10b981);
}

/* ========================================
   NAVIGATION BUTTONS
   Large touch targets for older users
   ======================================== */

.tutorial-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.tutorial-nav-main {
  display: flex;
  gap: 12px;
}

.tutorial-btn {
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  min-height: 48px; /* Minimum touch target for accessibility */
}

.tutorial-btn--skip {
  background: transparent;
  color: var(--color-text-secondary, #6b7280);
  padding: 14px 16px;
}

.tutorial-btn--skip:hover {
  color: var(--color-text, #1f2937);
  background: var(--color-background, #f3f4f6);
}

.tutorial-btn--back {
  background: var(--color-background, #f3f4f6);
  color: var(--color-text, #1f2937);
}

.tutorial-btn--back:hover {
  background: var(--color-border, #d1d5db);
}

.tutorial-btn--next {
  background: var(--color-primary, #3b82f6);
  color: white;
}

.tutorial-btn--next:hover {
  background: var(--color-primary-hover, #2563eb);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* ========================================
   MOBILE RESPONSIVENESS
   ======================================== */

@media (max-width: 640px) {
  .tutorial-tooltip {
    width: calc(100vw - 32px);
    max-width: none;
    padding: 20px;
    left: 16px !important;
    right: 16px;
  }

  .tutorial-tooltip-title {
    font-size: 1.25rem;
  }

  .tutorial-tooltip-text {
    font-size: 1.05rem;
  }

  .tutorial-btn {
    padding: 12px 16px;
    font-size: 1rem;
  }

  .tutorial-nav {
    flex-wrap: wrap;
  }

  .tutorial-nav-main {
    width: 100%;
    justify-content: stretch;
  }

  .tutorial-nav-main .tutorial-btn {
    flex: 1 1;
  }

  .tutorial-btn--skip {
    width: 100%;
    margin-bottom: 8px;
  }
}

/* ========================================
   HELP BUTTON (Header)
   ======================================== */

.help-menu-container {
  position: relative;
  display: flex;
  align-items: center;
}

.help-btn {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  padding: 0;
  border-radius: 50%;
  border: 2px solid var(--color-primary, #3b82f6);
  background: transparent;
  color: var(--color-primary, #3b82f6);
  font-weight: bold;
  font-size: 1.1rem;
  cursor: pointer;
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  aspect-ratio: 1 / 1;
  box-sizing: border-box;
}

.help-btn:hover {
  background: var(--color-primary, #3b82f6);
  color: white;
}

.help-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 0.5rem;
  background: #ffffff !important;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 280px;
  z-index: 9999;
  overflow: hidden;
}

.help-dropdown-item {
  width: 100%;
  padding: 0.875rem 1rem;
  text-align: left;
  background: #ffffff !important;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  color: #1f2937 !important;
  font-size: 1rem;
  display: block;
}

.help-dropdown-item:hover {
  background: #f3f4f6 !important;
}

.help-dropdown-item:first-child {
  border-radius: 0.5rem 0.5rem 0 0;
}

.help-dropdown-item:last-child {
  border-radius: 0 0 0.5rem 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tutorial/Tutorial.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;;6CAE6C;;AAE7C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa,EAAE,oDAAoD;EACnE,oBAAoB;AACtB;;AAEA;;;6CAG6C;;AAE7C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oDAAoD;EACpD,2CAA2C;EAC3C,oDAAoD;EACpD,oBAAoB;EACpB,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;;;;6CAI6C;;AAE7C;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb;;2CAEyC;EACzC,oBAAoB;EACpB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;;;6CAG6C;;AAE7C;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;AAClB;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;6CAG6C;;AAE7C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;6CAE6C;;AAE7C;EACE;IACE,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,+CAA+C;EAC/C,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/**\n * Tutorial System Styles\n * Designed for older, less tech-savvy users:\n * - Large text and touch targets\n * - High contrast\n * - Simple, clean design\n */\n\n/* ========================================\n   TUTORIAL OVERLAY\n   ======================================== */\n\n.tutorial-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3500; /* Above modals (2000) and ProcessingDialog (3000) */\n  pointer-events: none;\n}\n\n/* ========================================\n   SPOTLIGHT EFFECT\n   Uses box-shadow trick for dimming\n   ======================================== */\n\n.tutorial-spotlight {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* Allow clicks to pass through to underlying elements */\n  pointer-events: none;\n}\n\n.tutorial-spotlight-hole {\n  position: fixed;\n  border-radius: 8px;\n  /* Large box-shadow creates the dim overlay effect */\n  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.4);\n  /* Allow clicks to pass through the spotlight hole */\n  pointer-events: none;\n  /* Smooth transitions when moving between elements */\n  transition: all 0.3s ease-out;\n}\n\n/* Pulsing highlight animation to draw attention */\n.tutorial-spotlight-hole::before {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  right: -4px;\n  bottom: -4px;\n  border: 3px solid var(--color-primary, #3b82f6);\n  border-radius: 12px;\n  animation: tutorial-pulse 2s ease-in-out infinite;\n}\n\n@keyframes tutorial-pulse {\n  0%, 100% {\n    opacity: 0.6;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.02);\n  }\n}\n\n/* ========================================\n   TOOLTIP STYLES\n   Designed for older users: large text,\n   high contrast, simple language\n   ======================================== */\n\n.tutorial-tooltip {\n  position: fixed;\n  width: 320px;\n  max-width: calc(100vw - 32px);\n  background: var(--color-card-bg, #ffffff);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.2),\n    0 0 0 4px var(--color-primary, #3b82f6);\n  pointer-events: auto;\n  z-index: 3501;\n  animation: tutorial-tooltip-appear 0.3s ease-out;\n}\n\n@keyframes tutorial-tooltip-appear {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Center position for completion step */\n.tutorial-tooltip--center {\n  text-align: center;\n}\n\n/* ========================================\n   TOOLTIP ARROW\n   ======================================== */\n\n.tutorial-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 14px solid transparent;\n}\n\n/* Arrow pointing up (tooltip is below target) */\n.tutorial-tooltip-arrow--top {\n  top: -28px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-bottom-color: var(--color-primary, #3b82f6);\n}\n\n/* Arrow pointing down (tooltip is above target) */\n.tutorial-tooltip-arrow--bottom {\n  bottom: -28px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-top-color: var(--color-primary, #3b82f6);\n}\n\n/* Arrow pointing left (tooltip is to right of target) */\n.tutorial-tooltip-arrow--left {\n  left: -28px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-right-color: var(--color-primary, #3b82f6);\n}\n\n/* Arrow pointing right (tooltip is to left of target) */\n.tutorial-tooltip-arrow--right {\n  right: -28px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-left-color: var(--color-primary, #3b82f6);\n}\n\n/* ========================================\n   TOOLTIP CONTENT\n   Large, readable text for older users\n   ======================================== */\n\n.tutorial-tooltip-content {\n  margin-bottom: 20px;\n}\n\n.tutorial-tooltip-title {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--color-text, #1f2937);\n  margin: 0 0 12px 0;\n  line-height: 1.3;\n}\n\n.tutorial-tooltip-text {\n  font-size: 1.15rem;\n  color: var(--color-text-secondary, #6b7280);\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* ========================================\n   PROGRESS INDICATOR\n   ======================================== */\n\n.tutorial-progress {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--color-border, #d1d5db);\n}\n\n.tutorial-progress-text {\n  font-size: 0.95rem;\n  color: var(--color-text-secondary, #6b7280);\n}\n\n.tutorial-progress-dots {\n  display: flex;\n  gap: 8px;\n}\n\n.tutorial-progress-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--color-border, #d1d5db);\n  transition: all 0.2s ease;\n}\n\n.tutorial-progress-dot.active {\n  background: var(--color-primary, #3b82f6);\n  transform: scale(1.3);\n}\n\n.tutorial-progress-dot.completed {\n  background: var(--color-success, #10b981);\n}\n\n/* ========================================\n   NAVIGATION BUTTONS\n   Large touch targets for older users\n   ======================================== */\n\n.tutorial-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.tutorial-nav-main {\n  display: flex;\n  gap: 12px;\n}\n\n.tutorial-btn {\n  padding: 14px 24px;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  min-height: 48px; /* Minimum touch target for accessibility */\n}\n\n.tutorial-btn--skip {\n  background: transparent;\n  color: var(--color-text-secondary, #6b7280);\n  padding: 14px 16px;\n}\n\n.tutorial-btn--skip:hover {\n  color: var(--color-text, #1f2937);\n  background: var(--color-background, #f3f4f6);\n}\n\n.tutorial-btn--back {\n  background: var(--color-background, #f3f4f6);\n  color: var(--color-text, #1f2937);\n}\n\n.tutorial-btn--back:hover {\n  background: var(--color-border, #d1d5db);\n}\n\n.tutorial-btn--next {\n  background: var(--color-primary, #3b82f6);\n  color: white;\n}\n\n.tutorial-btn--next:hover {\n  background: var(--color-primary-hover, #2563eb);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* ========================================\n   MOBILE RESPONSIVENESS\n   ======================================== */\n\n@media (max-width: 640px) {\n  .tutorial-tooltip {\n    width: calc(100vw - 32px);\n    max-width: none;\n    padding: 20px;\n    left: 16px !important;\n    right: 16px;\n  }\n\n  .tutorial-tooltip-title {\n    font-size: 1.25rem;\n  }\n\n  .tutorial-tooltip-text {\n    font-size: 1.05rem;\n  }\n\n  .tutorial-btn {\n    padding: 12px 16px;\n    font-size: 1rem;\n  }\n\n  .tutorial-nav {\n    flex-wrap: wrap;\n  }\n\n  .tutorial-nav-main {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .tutorial-nav-main .tutorial-btn {\n    flex: 1;\n  }\n\n  .tutorial-btn--skip {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n}\n\n/* ========================================\n   HELP BUTTON (Header)\n   ======================================== */\n\n.help-menu-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.help-btn {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  padding: 0;\n  border-radius: 50%;\n  border: 2px solid var(--color-primary, #3b82f6);\n  background: transparent;\n  color: var(--color-primary, #3b82f6);\n  font-weight: bold;\n  font-size: 1.1rem;\n  cursor: pointer;\n  margin-right: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  aspect-ratio: 1 / 1;\n  box-sizing: border-box;\n}\n\n.help-btn:hover {\n  background: var(--color-primary, #3b82f6);\n  color: white;\n}\n\n.help-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 0.5rem;\n  background: #ffffff !important;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  min-width: 280px;\n  z-index: 9999;\n  overflow: hidden;\n}\n\n.help-dropdown-item {\n  width: 100%;\n  padding: 0.875rem 1rem;\n  text-align: left;\n  background: #ffffff !important;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s;\n  color: #1f2937 !important;\n  font-size: 1rem;\n  display: block;\n}\n\n.help-dropdown-item:hover {\n  background: #f3f4f6 !important;\n}\n\n.help-dropdown-item:first-child {\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n\n.help-dropdown-item:last-child {\n  border-radius: 0 0 0.5rem 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
